import { ErrorState, type ErrorStateProps } from '@/components/common/ErrorState'

export interface QueryErrorStateProps extends Omit<ErrorStateProps, 'onRetry' | 'fallbackKind'> {
  /** Pass a TanStack Query `refetch` straight through — retry awaits it. */
  onRetry?: () => Promise<unknown> | void
}

/**
 * ErrorState wired for data-fetch failures: defaults to network classification
 * and drives the retry button from the query's own refetch.
 */
export function QueryErrorState({
  onRetry,
  ...rest
}: QueryErrorStateProps): React.ReactElement {
  return <ErrorState {...rest} fallbackKind="network" onRetry={onRetry} />
}

QueryErrorState.displayName = 'QueryErrorState'
